module.exports = __webpack_public_path__ + "static/ways-of-escape-b4f30fd8df2507ba34ebff10f0a36275.jpg";